import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { AppStateHolder } from '../../shared';
import { SessionService, SidebarService } from '../../services';
import { NgTemplateOutlet, AsyncPipe } from '@angular/common';
import { TooltipModule } from 'primeng/tooltip';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [NgTemplateOutlet, TooltipModule, TranslateModule, AsyncPipe]
})
export class SidebarComponent {
  sidebarSrv = inject(SidebarService);
  private _ssnService = inject(SessionService);
  private _route = inject(Router);
  appStateHolder = inject(AppStateHolder);

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);


  constructor() { }

  public expandSidebar(): void {
    const expanded = !this.sidebarSrv.getStateExpanded;
    this.sidebarSrv.setExpand(expanded, true);
  }

  public goTo(link: string): void {
    this._route.navigate([link]);
  }

  public goBack(): void {
    this.sidebarSrv.goBack();
  }
}
